export default __webpack_public_path__ + "static/media/hero_1280.def5b517.jpg";